import { DATATABLE_ALL } from './constants';
import { ajaxPromise, checkChosenChanged, dtColumnIndicies, getDateFilter, getDtRowData, htmlEsc, initDateFilter, logerror, post, toggleSlide } from './utils';

if ($('#import_history_table').length === 1) {
    init_import_history();
}

function init_import_history() {
    toggleSlide($('#import_history_filter_toggle'), $('#import_history_filter_container'));
    $('#import_history_filter_container select.chosen').chosen({ width: '100%' });
    initDateFilter('#import_history_filter_date');
    checkChosenChanged($('#import_history_filter_container select.chosen'));
    $('#import_history_filter_container select.chosen').on('change', ({ target }) => checkChosenChanged($(target)));

    const getFilters = () => ({
        status: $('#import_history_filter_status').val(),
        type: $('#import_history_filter_type').val(),
        date: getDateFilter('#import_history_filter_date'),
    });

    const resetFilters = () => {
        $('#import_history_filter_status').val([]).trigger('chosen:updated');
        $('#import_history_filter_type').val([]).trigger('chosen:updated');
        $('#import_history_filter_date').val('-1').trigger('chosen:updated').trigger('change');
        $('#import_history_filter_date_first').val('');
        $('#import_history_filter_date_second').val('');
        checkChosenChanged($('#import_history_filter_container select.chosen'));
        table.ajax.reload();
    };

    $('#import_history_filter_reset').on('click', resetFilters);

    const columns: DataTables.ColumnSettings[] = [
        {
            title: 'Date',
            data: 'import_date_formatted',
            width: '180px',
        },
        {
            title: 'Filename',
            data: 'import_original',
        },
        {
            title: 'Type',
            data: 'type_label',
            width: '120px',
            // label is built in PHP, not a SQL alias, so it cannot be searched
            searchable: false,
        },
        {
            title: 'Records Created',
            data: 'record_count',
            width: '180px',
            className: 'text-center',
        },
        {
            title: 'Status',
            data: 'status_label',
            width: '120px',
            // label is built in PHP, not a SQL alias, so it cannot be searched
            searchable: false,
            render: (val, _, row: any) => {
                return `<span class="label label-${row.status_badge}">${val}</span>`;
            },
        },
        {
            title: 'Actions',
            orderable: false,
            searchable: false,
            width: '120px',
            className: 'text-center',
            data: null,
            render: () => {
                return '<button class="btn btn-sm btn-primary view-import-details">View Details</button>';
            },
        },
    ];

    const columnIndicies = dtColumnIndicies(columns);
    const tableOptions: DataTables.Settings = {
        ajax: {
            url: '/data/import_history_load',
            data: (postData: any) => ({
                ...postData,
                filters: JSON.stringify(getFilters()),
            }),
        },
        buttons: [
            {
                text: '<i class="fa fa-file-csv me-2"></i> Export',
                className: 'ml-2 btn btn-sm btn-secondary',
                action: ({ target }) => {
                    const $btn = $(target);
                    $btn.prop('disabled', true);

                    post('/export', {
                        type: 'import_history',
                        data: JSON.stringify(getFilters()),
                    });

                    setTimeout(() => $btn.prop('disabled', false), 1000);
                },
            },
            {
                text: '<i class="fa fa-print me-2"></i> Print',
                className: 'ml-2 btn btn-sm btn-secondary',
                action: ({ target }) => {
                    const $btn = $(target);
                    $btn.prop('disabled', true);

                    const params = {
                        ...table.ajax.params(),
                        filters: JSON.stringify(getFilters()),
                    };

                    post('/printout/import_history', { params: JSON.stringify(params) }, '_blank');

                    setTimeout(() => $btn.prop('disabled', false), 1000);
                },
            },
        ],
        columns,
        order: [[columnIndicies.import_date_formatted, 'desc']],
        pageLength: 25,
    };

    const table = $('#import_history_table').DataTable(tableOptions);

    // Reload table when filters change
    $('#import_history_filter_container').on('change', () => setTimeout(() => table.ajax.reload(), 250));

    $('#import_history_table').on('click', '.view-import-details', ({ target }) => {
        const row = getDtRowData(table, target);
        loadImportDetails(row.import_guid);
    });
}

let importDetailTable: DataTables.Api | null = null;

async function loadImportDetails(importGuid: string) {
    $('#import_detail_modal_body').html(`
        <div class="text-center">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
            <p>Loading...</p>
        </div>
    `);
    $('#import_detail_modal').modal('show');

    try {
        const response = await ajaxPromise('/data/import_detail_load', { import_guid: importGuid });
        if (response.rc !== 'OK') {
            $('#import_detail_modal_body').html(`
                <div class="alert alert-danger">
                    <strong>Error:</strong> ${htmlEsc(response.message || response.msg || 'Failed to load import details')}
                </div>
            `);
            return;
        }
        
        const { import: importData, status_label, status_badge, headers, combined_data, contract_count, record_count, row_count, spreadsheet_note, commit_error } = response;
        const createdCount = record_count ?? contract_count ?? 0;
        const importType = importData.import_type;
        const createdLabels: Record<string, string> = {
            vendor: 'Vendors Created:',
            user: 'Users Created:',
            contract: 'Contracts Created:',
        };
        const createdLabel = createdLabels[importType] || 'Records Created:';
        const detailNouns: Record<string, string> = {
            vendor: 'vendor',
            user: 'user',
            contract: 'contract',
        };
        const detailNoun = detailNouns[importType] || 'record';

        if (!combined_data || !Array.isArray(combined_data)) {
            $('#import_detail_modal_body').html(`
                <div class="alert alert-warning">
                    <strong>No data available:</strong> This import may not have any data rows.
                </div>
            `);
            return;
        }

        const summaryRows = spreadsheet_note
            ? `<tr>
                    <th style="width: 150px;">${createdLabel}</th>
                    <td><strong class="text-success">${createdCount}</strong></td>
                </tr>`
            : `<tr>
                    <th style="width: 150px;">Total Rows:</th>
                    <td>${row_count}</td>
                </tr>
                <tr>
                    <th>${createdLabel}</th>
                    <td><strong class="text-success">${createdCount}</strong></td>
                </tr>
                <tr>
                    <th>Not Created:</th>
                    <td>${row_count - createdCount}</td>
                </tr>`;

        let html = `
            <div class="row">
                <div class="col-md-6">
                    <h4>Import Information</h4>
                    <table class="table table-bordered table-sm">
                        <tr>
                            <th style="width: 120px;">Filename:</th>
                            <td>${htmlEsc(importData.import_original || 'N/A')}</td>
                        </tr>
                        <tr>
                            <th>Import Date:</th>
                            <td>${importData.import_date_formatted || 'N/A'}</td>
                        </tr>
                        <tr>
                            <th>Status:</th>
                            <td><span class="label label-${status_badge}">${htmlEsc(status_label)}</span></td>
                        </tr>
                    </table>
                </div>
                <div class="col-md-6">
                    <h4>Import Summary</h4>
                    <table class="table table-bordered table-sm">
                        ${summaryRows}
                    </table>
                </div>
            </div>
            ${commit_error ? `<div class="alert alert-danger">${htmlEsc(commit_error)}</div>` : ''}`;

        $('#import_detail_modal_title').text(`Import Details - ${importData.import_original || 'Import'}`);

        if (spreadsheet_note || combined_data.length === 0) {
            const message = spreadsheet_note
                ? htmlEsc(spreadsheet_note)
                : 'This import has no data rows.';
            $('#import_detail_modal_body').html(`
                ${html}
                <div class="alert alert-info" style="margin-top: 15px;">${message}</div>
            `);
            return;
        }

        html += `

            <hr>

            <h4>Import Details</h4>
            <p class="text-muted">Shows the original imported data with ${detailNoun} creation status</p>
            <table id="import_detail_table" class="table table-hover table-striped table-bordered display" style="width: 100%;"></table>
        `;

        $('#import_detail_modal_title').text(`Import Details - ${importData.import_original || 'Import'}`);
        $('#import_detail_modal_body').html(html);

        const columns: DataTables.ColumnSettings[] = [
            {
                title: 'Row',
                data: 'row_num',
                width: '60px',
            },
            {
                title: 'Status',
                data: 'status',
                width: '120px',
                render: (val, _, row: any) => {
                    return `<span class="label label-${row.status_class}">${val}</span>`;
                },
            },
        ];
        if (headers && Array.isArray(headers)) {
            headers.forEach((header: string, index: number) => {
                columns.push({
                    title: htmlEsc(header || `Column ${index + 1}`),
                    data: (row: any) => {
                        if (row.row && typeof row.row === 'object') {
                            return row.row[index] || '';
                        }
                        return '';
                    },
                    render: (val: string, type: string) => {
                        if (type === 'display' && val && val.length > 50) {
                            const truncated = val.substring(0, 50) + '...';
                            const escaped = htmlEsc(truncated);
                            const encodedFullText = encodeURIComponent(val);
                            const colTitle = header || `Column ${index + 1}`;
                            return `<span class="import-longtext-cell text-info" data-full-text="${encodedFullText}" data-title="${encodeURIComponent(colTitle)}" style="cursor: pointer; text-decoration: underline;">${escaped}</span>`;
                        }
                        return htmlEsc(val);
                    },
                });
            });
        }
        columns.push({
            title: 'Actions',
            orderable: false,
            searchable: false,
            width: '120px',
            data: null,
            render: (_: any, __: any, row: any) => {
                if (row.record && row.record.usr_id) {
                    return `<button class="btn btn-xs btn-primary view-user-btn" data-usr-id="${row.record.usr_id}">
                        <i class="fa fa-external-link"></i> View
                    </button>`;
                }
                if (row.record && row.record.vend_id && !row.contract) {
                    return `<button class="btn btn-xs btn-primary view-vendor-btn" data-vend-id="${row.record.vend_id}">
                        <i class="fa fa-external-link"></i> View
                    </button>`;
                }
                if (row.contract && row.contract.contract_id) {
                    return `<button class="btn btn-xs btn-primary view-contract-btn" 
                        data-vend-id="${row.contract.contract_vendid}" 
                        data-contract-guid="${row.contract.contract_guid}">
                        <i class="fa fa-external-link"></i> View
                    </button>`;
                }
                return '<span class="text-muted">—</span>';
            },
        });

        if (importDetailTable) {
            importDetailTable.destroy();
            $('#import_detail_table').empty();
        }

        importDetailTable = $('#import_detail_table')
            .on('click', '.view-contract-btn', function() {
                const $btn = $(this);
                const vendId = $btn.data('vend-id');
                const contractGuid = $btn.data('contract-guid');
                
                post('/ui/contract', {
                    vend_id: vendId,
                    contract_guid: contractGuid,
                });
            })
            .on('click', '.view-vendor-btn', function() {
                const vendId = $(this).data('vend-id');
                post('/ui/vendor_edit', { id: vendId });
            })
            .on('click', '.view-user-btn', function() {
                const usrId = $(this).data('usr-id');
                post('/ui/setup', {
                    start: 'users',
                    params: JSON.stringify({ usr_id: usrId }),
                });
            })
            .on('click', '.import-longtext-cell', function() {
                const $cell = $(this);
                const fullText = decodeURIComponent($cell.data('full-text'));
                const title = decodeURIComponent($cell.data('title'));
                $('#import_field_text_modal_label').text(title);
                $('#import_field_text_modal_content').text(fullText);
                $('#import_field_text_modal').modal('show');
            })
            .DataTable({
                data: combined_data,
                columns: columns,
                buttons: [
                    {
                        text: '<i class="fa fa-file-csv me-2"></i> Export',
                        className: 'ml-2 btn btn-sm btn-secondary',
                        action: ({ target }) => {
                            const $btn = $(target);
                            $btn.prop('disabled', true);

                            post('/export', {
                                type: 'import_detail',
                                data: JSON.stringify({ import_guid: importGuid }),
                            });

                            setTimeout(() => $btn.prop('disabled', false), 1000);
                        },
                    },
                ],
                pageLength: 25,
                responsive: false,
                scrollX: true,
                scrollCollapse: true,
                order: [[0, 'asc']],
                serverSide: false,
                ajax: undefined,
                initComplete: function() {
                    const api = (this as any).api() as DataTables.Api;
                    const $wrapper = $('#import_detail_table_wrapper');
                    const $scrollBody = $wrapper.find('.dataTables_scrollBody');
                    const $scroll = $wrapper.find('.dataTables_scroll');
                    const adjust = () => api.columns.adjust();

                    // The modal may still be opening when the rows arrive, so the
                    // header copy is measured before the dialog has its final width.
                    $('#import_detail_modal').one('shown.bs.modal', adjust);

                    if ($scrollBody.length && $scroll.length) {
                        $wrapper.find('.doubleScroll-scroll-wrapper').remove();

                        setTimeout(() => {
                            $scrollBody.doubleScroll({
                                $insertBefore: $scroll,
                                resetOnWindowResize: true
                            });
                            adjust();
                        }, 100);
                    } else {
                        adjust();
                    }
                },
            });

    } catch (error) {
        $('#import_detail_modal_body').html(`
            <div class="alert alert-danger">
                <strong>Error:</strong> Failed to load import details. Please try again.
            </div>
        `);
        logerror('load import details', error);
    }
}

// Print page handler
if ($('#import_history_printout').length === 1) {
    const deployPrintOut = async () => {
        const params = JSON.parse(atob($('#import_history_printout').data('params')));

        try {
            const res = await ajaxPromise('/data/import_history_load', {
                ...params,
                mode: DATATABLE_ALL, // DATATABLE_ALL
            });

            $('#spinner').show();

            const table = (
                <table className="table table-condensed table-striped" style="width: 100%;">
                    <thead>
                        <tr>
                            {res.headers.map((col: string) => (
                                <th>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {res.data.map((row: string[], index: number) => (
                            <tr className={index % 2 == 0 ? 'odd' : 'even'} style="border-bottom: 1px solid #d0d0d0;">
                                {row.map((cell: string) => (
                                    <td>{cell != null ? cell : ''}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
            $('#import_history_printout').append(table);

            setTimeout(() => {
                $('#spinner').hide();
                window.print();
            }, 1000);
        } catch (error) {
            logerror('import history print', error);
        }
    };

    deployPrintOut();
}